import React from 'react';

const Card = ({ loading, title, subtitle, subtitle2, count, subcount, subcount2, icon, color }) => (
    <div className="card card-stats mb-4 mb-xl-0">
        <div className="card-body">
            <div className="row">
                <div className="col">
                    <h5 className="card-title text-uppercase text-muted mb-0">{title}</h5>
                    <span className="h2 font-weight-bold mb-0">{count}</span>
                </div>
                <div className="col-auto">
                    <div className={`icon icon-shape ${color} text-white rounded-circle shadow`}>
                        <i className={icon} />
                    </div>
                </div>
            </div>
            <div className="row">
                { subtitle &&
                  <div className="col">
                      <br/>
                      <h5 className="card-title text-uppercase text-muted mb-0">{subtitle}</h5>
                      <span className="h2 font-weight-bold mb-0">{subcount}</span>
                  </div>
                }
                { subtitle2 &&
                  <div className="col">
                      <br/>
                      <h5 className="card-title text-uppercase text-muted mb-0">{subtitle2}</h5>
                      <span className="h2 font-weight-bold mb-0">{subcount2}</span>
                  </div>
                }
            </div>
            { loading &&
                <div className="card-loading reveal">
                    <div className="spinner-linear spinner-info align-self-start">
                        <div className="line" />
                    </div>
                </div>
            }
            <p className="mt-3 mb-0 text-muted text-sm" style={{ opacity: 0 }}>
                <span className="text-success mr-2"><i className="fa fa-arrow-up"></i> 3.48%</span>
                <span className="text-nowrap">desde o último mês</span>
            </p>
        </div>
    </div>
);

export default Card;



// WEBPACK FOOTER //
// ./src/components/Pages/Dashboard/Header/Card.js